import { IPartnerMarketLeasing } from 'legacy/lut/features/partner360/marketInfo'

import { jbpMarketLeasingDataSource } from './configs'
import { getJBPMarketLeasingCrud } from './helpers/getJBPMarketLeasingCrud'
import { mapMarketLeasingTo1018 } from './mappings/mapMarketLeasingTo1018'
import { IJBPMarketLeasingCrudParams } from './models'

export interface IUpdatedPartnerMarketLeasing extends IPartnerMarketLeasing {
  entryId: number
}

export const updatePartnerMarketLeasing = async (
  params: IJBPMarketLeasingCrudParams,
  formData: IUpdatedPartnerMarketLeasing
) => {
  const marketLeasingCrud = getJBPMarketLeasingCrud(params)

  const mappedData = mapMarketLeasingTo1018({
    ...params,
    ...formData,
  })

  const [updatedItem] = await marketLeasingCrud.update(jbpMarketLeasingDataSource, [mappedData])
  return updatedItem
}
